import React, { Component, Fragment } from "react";
import {
  FormGroup,
  ControlLabel,
  Button,
  FormControl,
  HelpBlock,
} from "react-bootstrap";
import Popup from "reactjs-popup";
import { Auth } from "aws-amplify";
import QRCode from "qrcode.react";
// import LoaderButton from "../LoaderButton";

class EnableTotpPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupOpen: false,
      isLoading: false,
      user: "",
      QrCode: "",
      showMfa: false,
      mfaToken: "",
      phoneNumber: "",
      mfaType: props.mfaType || "TOTP", // Default to TOTP if not specified
      isPhoneNumberChangeFlow: !!props.isPhoneNumberChangeFlow,
      currentPhoneNumber: "",
      verificationCode: "",
      phoneNumberSubmitted: false,
    };
  }

  async componentDidMount() {
    const user = await Auth.currentAuthenticatedUser({
      bypassCache: true,
    });
    this.setState(
      {
        popupOpen: this.props.props.showEnableTotpPopup,
        user: user,
        currentPhoneNumber:
          (user && user.attributes && user.attributes.phone_number) || "",
        phoneNumber:
          this.state.isPhoneNumberChangeFlow &&
          user &&
          user.attributes &&
          user.attributes.phone_number
            ? user.attributes.phone_number
            : "",
      },
      async () => {
        if (this.state.mfaType === "TOTP") {
          await this.enableTOTP();
        } else {
          // For SMS type, we show the phone number input form
          this.setState({ showMfa: true });
        }
      }
    );
  }

  enableTOTP = async () => {
    await Auth.setupTOTP(this.state.user).then((code) => {
      // You can directly display the `code` to the user or convert it to a QR code to be scanned.
      // E.g., use following code sample to render a QR code with `qrcode.react` component:
      let QrCode =
        "otpauth://totp/AWSCognito:" +
        "Documentsync-MFA" +
        "?secret=" +
        code +
        "&issuer=" +
        "www.DocumentSync.com";
      this.setState({ QrCode: QrCode }, () => this.setState({ showMfa: true }));
    });
  };

  formatUSPhoneNumber(phone) {
    let formatted = phone.trim();

    // If it already starts with +1, return it as is
    if (formatted.startsWith("+1")) {
      return formatted;
    }

    // If it starts with '+' but not '+1', remove the '+'
    if (formatted.startsWith("+")) {
      formatted = formatted.slice(1);
    }

    // If it now starts with '1', remove that leading '1'
    if (formatted.startsWith("1")) {
      formatted = formatted.slice(1);
    }

    // Prepend +1 to whatever is left
    return `+1${formatted}`;
  }

  // Trigger code send (update phone number and request code)
  setupSMS = async (e) => {
    e.preventDefault();
    this.setState({ isLoading: true });

    try {
      if (this.state.phoneNumber) {
        await Auth.updateUserAttributes(this.state.user, {
          phone_number: this.formatUSPhoneNumber(this.state.phoneNumber),
        });
        // Trigger sending of the verification code via SMS
        await Auth.verifyCurrentUserAttribute("phone_number");
        this.setState({
          phoneNumberSubmitted: true,
          isLoading: false,
        });
      }
    } catch (error) {
      console.error("Error setting up SMS MFA:", error);
      alert("Failed to setup SMS MFA: " + error.message);
      this.setState({ isLoading: false });
    }
  };

  // Verify code and then set SMS MFA
  verifySMSCode = async (e) => {
    e.preventDefault();
    this.setState({ isLoading: true });

    try {
      await Auth.verifyCurrentUserAttributeSubmit(
        "phone_number",
        this.state.verificationCode
      );

      // Refresh user object to get updated verified attributes
      const updatedUser = await Auth.currentAuthenticatedUser({
        bypassCache: true,
      });
      console.log(
        "Phone verified:",
        updatedUser.attributes.phone_number_verified
      );

      // Now that the phone is verified, set SMS as the preferred MFA method
      await Auth.setPreferredMFA(updatedUser, "SMS");

      this.closePopup();
      this.props.handleHideEnableButton();
    } catch (error) {
      console.error("Error verifying SMS code:", error);
      alert("Failed to verify code: " + error.message);
      this.setState({ isLoading: false });
    }
  };

  closePopup = () => {
    this.setState({ popupOpen: false });
    this.props.unmountMe();
  };

  handleMfaConfirmation = async (e) => {
    e.preventDefault();

    if (this.state.mfaType === "TOTP") {
      Auth.verifyTotpToken(this.state.user, this.state.mfaToken)
        .then(async () => {
          // don't forget to set TOTP as the preferred MFA method
          Auth.setPreferredMFA(this.state.user, "TOTP");
          this.closePopup();
          this.props.handleHideEnableButton();
        })
        .catch((e) => {
          console.log(e);
          alert("Failed to verify TOTP token: " + e.message);
        });
    }
  };

  renderTOTPSetup() {
    return (
      <div>
        <form onSubmit={this.handleMfaConfirmation}>
          <FormGroup>
            <HelpBlock>
              Scan the QR code with your preferred authenticator app (For
              example Google Authenticator)
            </HelpBlock>
          </FormGroup>
          <FormGroup>
            <QRCode value={this.state.QrCode} />
          </FormGroup>
          <FormGroup controlId="MFA">
            <ControlLabel>
              Enter Code From Authenticator to setup MFA:
            </ControlLabel>
            <FormControl
              componentClass="input"
              onChange={(e) => this.setState({ mfaToken: e.target.value })}
              type="text"
              autoComplete="off"
              required
            ></FormControl>
          </FormGroup>
          <FormGroup>
            <Button
              bsSize="small"
              bsClass="btn btn-outline-secondary"
              type="submit"
              disabled={this.state.isLoading}
            >
              {this.state.isLoading ? "Processing..." : "Enable MFA"}
            </Button>
          </FormGroup>
        </form>
      </div>
    );
  }

  renderSMSSetup() {
    if (this.state.phoneNumberSubmitted) {
      return (
        <form onSubmit={this.verifySMSCode}>
          <FormGroup>
            <HelpBlock>
              {this.state.isPhoneNumberChangeFlow
                ? "A verification code has been sent to your updated phone number. Enter the code below to finish updating your SMS MFA number."
                : "A verification code has been sent to your phone number. Enter the code below to complete SMS MFA setup."}
            </HelpBlock>
          </FormGroup>
          <FormGroup controlId="verificationCode">
            <ControlLabel>Verification Code:</ControlLabel>
            <FormControl
              componentClass="input"
              onChange={(e) =>
                this.setState({ verificationCode: e.target.value })
              }
              type="text"
              value={this.state.verificationCode}
              autoComplete="off"
              required
            ></FormControl>
          </FormGroup>
          <FormGroup>
            <Button
              bsSize="small"
              bsClass="btn btn-outline-secondary"
              type="submit"
              disabled={this.state.isLoading}
            >
              {this.state.isLoading
                ? "Verifying..."
                : this.state.isPhoneNumberChangeFlow
                ? "Verify and Update Number"
                : "Verify Code"}
            </Button>
          </FormGroup>
        </form>
      );
    }

    return (
      <form onSubmit={this.setupSMS}>
        {this.state.isPhoneNumberChangeFlow && this.state.currentPhoneNumber && (
          <FormGroup>
            <HelpBlock>
              Current MFA phone number on your account:{" "}
              {this.state.currentPhoneNumber}
            </HelpBlock>
          </FormGroup>
        )}
        <FormGroup>
          <HelpBlock>
            {this.state.isPhoneNumberChangeFlow
              ? "Enter a new phone number for SMS MFA verification codes. Please include country code (e.g., +1 for US)."
              : "Enter your phone number to receive SMS verification codes. Please include country code (e.g., +1 for US)."}
          </HelpBlock>
        </FormGroup>
        <FormGroup controlId="phoneNumber">
          <ControlLabel>
            {this.state.isPhoneNumberChangeFlow
              ? "New Phone Number:"
              : "Phone Number:"}
          </ControlLabel>
          <FormControl
            componentClass="input"
            onChange={(e) => this.setState({ phoneNumber: e.target.value })}
            type="tel"
            placeholder="+12025551234"
            value={this.state.phoneNumber}
            autoComplete="tel"
            required
          ></FormControl>
        </FormGroup>
        <FormGroup>
          <Button
            bsSize="small"
            bsClass="btn btn-outline-secondary"
            type="submit"
            disabled={this.state.isLoading}
          >
            {this.state.isLoading
              ? "Processing..."
              : this.state.isPhoneNumberChangeFlow
              ? "Send Code to New Number"
              : "Send Verification Code"}
          </Button>
        </FormGroup>
      </form>
    );
  }

  render() {
    return (
      <Fragment>
        <Popup
          contentStyle={{
            width: "590px",
            borderRadius: "15px",
            padding: "15px",
            minWidth: "590px !important",
          }}
          open={this.state.popupOpen}
          modal
          closeOnDocumentClick={false}
          onClose={this.closePopup}
        >
          <div>
            {/* eslint-disable-next-line */}
            <a className="close" onClick={this.closePopup}>
              &times;
            </a>
            {this.state.showMfa && (
              <div>
                <h4>
                  {this.state.mfaType === "TOTP"
                    ? "Authenticator App Setup"
                    : this.state.isPhoneNumberChangeFlow
                    ? "Change SMS MFA Number"
                    : "SMS MFA Setup"}
                </h4>
                {this.state.mfaType === "TOTP"
                  ? this.renderTOTPSetup()
                  : this.renderSMSSetup()}
              </div>
            )}
          </div>
        </Popup>
      </Fragment>
    );
  }
}

export default EnableTotpPopup;
